store.admin.image = {};
store.admin.image.$images = {};
store.admin.image.initAdd = function(userId) {
	store.admin.image.uploadify(userId, function($form, response) {
		$form.find('#submit').bind('click', function(e){
			e.preventDefault();
			window.location = $form.data('images');
		});
		var j = jQuery.parseJSON(response);
		$('#ffileList').find('ul').append('<li><img src="' + j.tiny + '" /></li>');
	}, function($form) {
		$form.find('#submit').removeAttr('disabled');
	});
};
store.admin.image.init = function(userId, rows) {
	store.admin.image.$images = $('#storeImages');
	for (var i = 0, c = rows.length; i < c; i++) {
		store.admin.image.addRow(rows[i]);
	}
	store.admin.image.afterUpdate();
	store.admin.image.uploadify(userId, function($form, response){
		var j = jQuery.parseJSON(response);
		store.admin.image.addRow(j);
		store.admin.image.afterUpdate();
	});
};
store.admin.image.sortableImages = function() {
	store.admin.image.$images.find('tbody').sortable({
		helper: function (e, ui) {
			ui.children().each(function(){
				$(this).width($(this).width());
			});
			return ui;
		},
		stop: function(/*e, ui*/) {
			store.admin.image.fixTop();
		},
		handle: 'td.handle'
	}).disableSelection();
};
store.admin.image.fixTop = function() {
	var trs = store.admin.image.$images.find('tbody tr');
	trs.removeClass('cover');
	$(trs.get(0)).addClass('cover');
};
store.admin.image.afterUpdate = function() {
	store.admin.image.sortableImages();
	store.admin.switchLang($('ul.langPicker').data('current'));
	store.admin.image.fixTop();
	if ($.isFunction($.fn.responsiveImg)) {
		store.admin.image.$images.find('img').responsiveImg();
	}
	store.admin.image.$images.find('a.fancybox').fancybox();
};
store.admin.image.addRow = function(i) {
	var imageId = i.data.id;
	var labels = i.data.label;
	var trClass = '';
	var active = (i.data.active == 1);
	if (active) {
		trClass += ' active';
	}
	var imgTag = (i.tag) ? i.tag : '&nbsp;';
	var tdHandle = '<td class="handle"><span class="handle">&nbsp;</span></td>';
	var tdImg = '<td class="img">' + imgTag + '</td>';
	var labelName = 'images[' + imageId + '][label]';
	var tdLabel = '<td class="labels">';
	for (var langCode in store.admin.languages) {
		//noinspection JSUnfilteredForInLoop
		var l = (labels && labels[langCode]) ? labels[langCode] : '';
		tdLabel += '<span class="lang_wrapper lang_wrapper_' + langCode + '">' +
			'<input type="text" class="text"' +
			' name="' + labelName + '[' + langCode + ']"' +
			' id="' + labelName + '_' + langCode + '"' +
			' value="' + l + '"' +
			' />';
		tdLabel += '</span>';
	}
	tdLabel += '</td>';
	var tdActiveChecked = (active) ? ' checked="checked="' : '';
	var tdActive = '<td class="active">' +
		'<input type="hidden" name="images[' + imageId + '][active]" value="0" />' +
		'<input type="checkbox" name="images[' + imageId + '][active]" ' +
		'id="images_active_' + imageId + '" value="1" ' +
		tdActiveChecked +
		'/>' +
		'</td>';
	var tdDelete = '<td class="delete">' +
		'<input type="hidden" name="sort[]" value="' + imageId + '" />' +
		'<input type="hidden" name="images[' + imageId + '][delete]" value="0" />' +
		'<input type="checkbox" name="images[' + imageId + '][delete]" ' +
		'id="images_delete_' + imageId + '" value="1" ' +
		'/>' +
		'</td>';
	var tds = tdHandle+tdImg+tdLabel+tdActive+tdDelete;
	var tr = "<tr class=\"" + trClass + "\">" + tds + "</tr>";

	store.admin.image.$images.find('tbody').append(tr);
};
store.admin.image.uploadify = function(userId, complete, allComplete) {
	var $form = $('#imageNew');
	var $n = $('#notice');
	var $ffile = $('#ffile');
	var config = {
		'removeOnSuccess': true,
		'uploader'  : '/_moya/js/jquery/uploadify/uploadify.swf',
		'script'    : $form.attr('data-script'),
		'cancelImg' : '/_moya/js/jquery/uploadify/cancel.png',
		'auto'      : true,
		'multi'		: true,
		'folder'    : '/tmp',
		'fileDesc'	: $form.attr('data-desc'),
		'fileExt'	: '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG',
		'buttonText': $form.attr('data-browse'),
		'onError'  : function (/*event,ID,fileObj,errorObj*/) {
			$n.html('<div class="message"><div class="error">'+$form.attr('data-errsave')+'</div></div>');
		},
		'onComplete'	: function(event, queueID, fileObj, response) {
			switch(response) {
				case 'noAlbum':
					$n.html('<div class="message"><div class="error">'+$form.attr('data-errnoalbum')+'</div></div>');
					break;
				case 'noSave':
					$n.html('<div class="message"><div class="error">'+$form.attr('data-errsave')+'</div></div>');
					break;
				default:
					$n.html('');
					try {
						complete.call(this, $form, response);
					}
					catch (e) {
						if (console && console.log) {
							console.log(e);
						}
					}
					break;
			}
		},
		'onAllComplete' : function(){
			if (allComplete) {
				allComplete.call(this, $form);
			}
		},
		'onSelect'	: function() {
			var data = {
				'userId' : userId
			};
			$ffile.uploadifySettings('scriptData', data);
		}
	};
	$ffile.uploadify(config);

	$('#ffileQueue').parent().append('<div id=\"ffileList\"><ul></ul></div>');
};
